/**
 * OneHeader defined sizes
 * https://github.com/volkswagen-onehub/audi-feature-app-header/blob/develop/src/components/AudiHeader/AudiHeaderStyles.tsx
 */
//
export const ONE_HEADER_HEIGHT = '72px';

export const DISPLAY_SIZE = {
  MOBILE: '375px',
  TABLET: '768px',
  SMALL_DESKTOP: '1024px',
  DESKTOP: '1440px',
  LARGE_DESKTOP: '1920px',
};
